var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navigation",class:_vm.loc},[_c('transition',{attrs:{"name":"appear","mode":"out-in","appear":""}},[(_vm.loc !== 'home')?_c('div',{staticClass:"logo"},[_vm._t("logo")],2):_vm._e()]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }